import { NgModule } from '@angular/core';
//import { BaseBeneficiaryPersonalDetailsLibraryService } from 'base-beneficiary-personal-details-library';
import { PrimengLibraryModule } from 'primeng-library';
import { BeneficiaryPersonalDetailsLibraryComponent } from './beneficiary-personal-details-library.component';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { DateFormatModule } from 'date-format';
import { LastUpdateLibraryModule } from 'last-update-library';
import { TaskNotesLibModule } from 'task-notes-lib';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AvatarModule } from 'ngx-avatar';
import { MatIconModule } from '@angular/material/icon';
import { BaseBeneficiaryPersonalDetailsLibraryService } from 'base-beneficiary-personal-details-library';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
@NgModule({
  declarations: [BeneficiaryPersonalDetailsLibraryComponent],
  imports: [
    PrimengLibraryModule,
    StepStatusUpdateComponentLibraryModule,
    // EditPersonalDetailsModule,
    DateFormatModule,
    LastUpdateLibraryModule,
    TaskNotesLibModule,
    AssigningTaskLibraryModule,
    CustomQuestionnaireModule,
    MaximizeDialogLibraryModule,
    MatListModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSelectModule,
    AvatarModule,
    MatIconModule,
    // SimplePersonalDetailLibraryModule,
    GenericBeneficiaryPersonalDetailsLibraryModule,
    MatButtonToggleModule,
  ],
  providers: [BaseBeneficiaryPersonalDetailsLibraryService],
  exports: [BeneficiaryPersonalDetailsLibraryComponent]
})
export class BeneficiaryPersonalDetailsLibraryModule { }
